export { CELL_TYPE, TimeCellType } from "./timeType.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/timeType/index.mjs
// module id = 1119
// module chunks = 1